import React, { useEffect, useMemo, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Spin } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';

import eCoachVMSApi from '../Api';
import '../css/login.css';
import { fetchUserSession } from '../store/reducers/sessionReducer';

const TokenLogin = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // Memoize the API instance to prevent re-creation on every render
    const { baseURL } = useMemo(() => eCoachVMSApi(), []);
    const authInProgress = useRef(false);

    const token = searchParams.get('token');
    const cal_id = searchParams.get('cal_id');

    useEffect(() => {
        // Prevent duplicate calls
        if (authInProgress.current) {
            return;
        }

        console.log(sessionStorage.getItem('session'));

        if (!sessionStorage.getItem('session') && !token) {
            navigate('/login');
            return;
        }

        // If we already have a session and no token, redirect immediately
        if (sessionStorage.getItem('session') && !token) {
            navigate('/service-calendar');
            return;
        }

        // Only proceed if we have a token and no session
        if (token && !sessionStorage.getItem('session')) {
            authInProgress.current = true;

            const authenticateWithToken = async () => {
                try {
                    const result = await baseURL.post(
                        '/loginvms',
                        {
                            vms_token: token,
                            cal_id: cal_id
                        },
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            withCredentials: true
                        }
                    );

                    const responseData = result?.data?.data;

                    if (responseData?.session_id) {
                        sessionStorage.setItem('session', responseData.session_id);
                        await dispatch(fetchUserSession()).unwrap();
                        if (responseData?.redirect_url && responseData?.redirect_url?.length > 0) {
                            navigate(responseData.redirect_url);
                        } else {
                            navigate('/service-calendar');
                        }
                    } else {
                        navigate('/login');
                    }
                } catch (err) {
                    console.error('Token authentication failed:', err);
                    navigate('/login');
                }
            };

            authenticateWithToken();
        }

        // Cleanup function
        return () => {
            authInProgress.current = false;
        };
    }, [token, cal_id, dispatch, baseURL]);

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
            <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full mx-4">
                <div className="text-center">
                    <Spin size="large" />
                    <div className="mt-4">
                        <h2 className="text-xl font-semibold text-gray-800 mb-2">Authenticating</h2>
                        <p className="text-gray-600">Please wait while we verify your credentials...</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TokenLogin;
